// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"a7d5ffaf","193":"e2e32f5e","307":"9699c776","366":"8544abd8","435":"b3c11248","590":"e4435526","629":"37b12e22","787":"8c57b075","981":"5cc05d7e"}[chunkId] + ".chunk.js";
};